import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-section"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsibleSection',
  props: {
    isVisible: { type: Boolean, default: false },
    inverted: { type: Boolean, default: false },
    useDefaultToggle: { type: Boolean, default: false }
  },
  setup(__props: any) {


const props = __props;

const toggleIcon = () => {
  return props.isVisible
    ? "fa-solid fa-chevron-down"
    : "fa-solid fa-chevron-up";
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "wrapper" }, _ctx.$attrs), [
    (!!_ctx.$slots.toggle || __props.useDefaultToggle)
      ? _renderSlot(_ctx.$slots, "toggle", { key: 0 }, () => [
          _createVNode(_component_font_awesome_icon, {
            class: "",
            icon: toggleIcon()
          }, null, 8, ["icon"])
        ])
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: __props.inverted ? 'slide-up' : 'slide-down'
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _cache[0] || (_cache[0] = _createTextVNode("Default content to slide...", -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["name"])
  ], 16))
}
}

})